(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["curtainsuk-trust-footer"] && !Shopify.designMode) return;
  try {
    (() => {
  document.querySelectorAll('[data-cuk-trust-footer]').forEach(root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const media = matchMedia('(min-width:750px)');
    const adapt = () => root.querySelectorAll('[data-trust-group]').forEach(group => { group.open = media.matches; });
    adapt();
    media.addEventListener('change', adapt);
    root.querySelector('[data-cookie-settings]')?.addEventListener('click', async () => {
      const status = root.querySelector('[data-cookie-status]');
      status.textContent = '';
      try {
        if (typeof window.privacyBanner?.showPreferences !== 'function') throw new Error('UNAVAILABLE');
        await window.privacyBanner.showPreferences();
      } catch {
        status.textContent = root.dataset.cookieUnavailable;
      }
    });
  });
})();
  } catch(e) { console.error(e); }
})();

})();
